// https://gist.github.com/paulirish/5558557#stronger-full-capability-test-for-localstorage-with-ios-private-browsing-protection

// UPDATED: https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
function storageAvailable(type) {
    try {
        var storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return false;
    }
}
function isLocalStorageSupported() {
    return storageAvailable('localStorage');
}

function isSessionStorageSupported() {
    return storageAvailable('sessionStorage');
}

module.exports = {
    isLocalStorageSupported: isLocalStorageSupported,
    isSessionStorageSupported: isSessionStorageSupported
}
